<script>
import EmailLabel from '@/js/components/common/labels/EmailLabel';

export default {
    name: 'DocumentAuthorsEmails',

    functional: true,

    props: {
        document: {type: Object, required: true},
    },

    render(createElement, {props, data}) {
        const emails = (props.document.authors_emails || [])
            .map((email) => createElement(EmailLabel, {
                staticClass: 'card-label',
                props: {email: email},
            }));

        if (emails.length === 0) {
            data.props = {email: null};

            return createElement(EmailLabel, data);
        }

        return createElement('span', data, emails);
    },
};
</script>
